var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C10.2426 11 11.25 9.99264 11.25 8.75C11.25 7.50736 10.2426 6.5 9 6.5C7.75736 6.5 6.75 7.50736 6.75 8.75C6.75 9.99264 7.75736 11 9 11Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2428 12.9927L10.0605 16.175C9.77924 16.456 9.39794 16.6138 9.00038 16.6138C8.60282 16.6138 8.22151 16.456 7.94025 16.175L4.75725 12.9927C3.91817 12.1536 3.34675 11.0845 3.11527 9.92064C2.88378 8.75676 3.00262 7.55038 3.45676 6.45404C3.91089 5.3577 4.67993 4.42065 5.66661 3.76137C6.6533 3.1021 7.81333 2.75021 9 2.75021C10.1867 2.75021 11.3467 3.1021 12.3334 3.76137C13.3201 4.42065 14.0891 5.3577 14.5433 6.45404C14.9974 7.55038 15.1162 8.75676 14.8847 9.92064C14.6533 11.0845 14.0818 12.1536 13.2428 12.9927V12.9927Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.dc27a99439d43d9d4efcb93bc2c8c303.svg";
export { ForwardRef as ReactComponent };